var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectrelevant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H23V23H0V0Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83341 5.75033C4.89194 5.75033 5.75008 4.89219 5.75008 3.83366C5.75008 2.77511 4.89194 1.91699 3.83341 1.91699C2.77487 1.91699 1.91675 2.77511 1.91675 3.83366C1.91675 4.89219 2.77487 5.75033 3.83341 5.75033Z",
    stroke: "#D9D9D9",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79175 20.126C6.37956 20.126 7.66675 18.8388 7.66675 17.251C7.66675 15.6632 6.37956 14.376 4.79175 14.376C3.20393 14.376 1.91675 15.6632 1.91675 17.251C1.91675 18.8388 3.20393 20.126 4.79175 20.126Z",
    stroke: "#D9D9D9",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2085 21.084C19.7963 21.084 21.0835 19.7968 21.0835 18.209C21.0835 16.6212 19.7963 15.334 18.2085 15.334C16.6207 15.334 15.3335 16.6212 15.3335 18.209C15.3335 19.7968 16.6207 21.084 18.2085 21.084Z",
    stroke: "#D9D9D9",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5418 13.4176C12.6589 13.4176 14.3752 11.7014 14.3752 9.58431C14.3752 7.46721 12.6589 5.75098 10.5418 5.75098C8.42473 5.75098 6.7085 7.46721 6.7085 9.58431C6.7085 11.7014 8.42473 13.4176 10.5418 13.4176Z",
    stroke: "#D9D9D9",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2919 5.75033C17.3504 5.75033 18.2086 4.89219 18.2086 3.83366C18.2086 2.77511 17.3504 1.91699 16.2919 1.91699C15.2334 1.91699 14.3752 2.77511 14.3752 3.83366C14.3752 4.89219 15.2334 5.75033 16.2919 5.75033Z",
    stroke: "#D9D9D9",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.271 5.27148L7.18766 7.18815",
    stroke: "#D9D9D9",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3751 5.75098L13.4167 6.70931",
    stroke: "#D9D9D9",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2917 16.0527L13.4167 12.459",
    stroke: "#D9D9D9",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7085 14.8551L8.62516 12.9385",
    stroke: "#D9D9D9",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectrelevant);
export default __webpack_public_path__ + "static/media/connectrelevant.4206f719f2ee75fb39d01968ac5cfffd.svg";
export { ForwardRef as ReactComponent };